import { Button, message, notification } from "antd";
import { addCandidateToRole } from "api/project.api";
import { useAppDispatch } from "hooks/reduxHooks";
import { SvgIcons } from "Icon/SvgIcons";
import React, { useState, useEffect } from "react";
import { toggleStatsRefresh } from "store/slices/talentPool";

interface ShortlistCandidateProps {
    selectedPool: number;
    candidateId: number;
    isSelected?: boolean;
    handleShortlistCandidate?: any;
    searchId: number | string;
}

const ShortlistCandidate: React.FC<ShortlistCandidateProps> = ({
    selectedPool,
    candidateId,
    searchId,
    isSelected = false,
    handleShortlistCandidate
}) => {
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(isSelected);
    const dispatch = useAppDispatch();
    // keep local state in sync if parent changes
    useEffect(() => {
        setSelected(isSelected);
    }, [isSelected]);

    const handleShortList = async () => {
        setLoading(true);
        try {
            await addCandidateToRole({
                jobs: [selectedPool],
                candidates: [candidateId],
                is_shortlisted: !selected,
                search_log_id: searchId
            });

            // toggle local state
            setSelected((prev) => !prev);

            // notify parent (if needed)
            handleShortlistCandidate?.(candidateId);
            dispatch(toggleStatsRefresh());
            notification.success({
                message: "Success",
                description: !selected
                    ? "Candidate successfully shortlisted!"
                    : "Candidate unshortlisted!"
            });
        } catch (error) {
            message.error(`Failed to shortlist candidate: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleShortList}
            loading={loading}
            icon={selected ? SvgIcons.thumbFilledIcon : SvgIcons.thumbIcon}
            type="default"
            className={`${loading ? "text-primary" : "text-[#6941C6]"} w-12 h-10 rounded-md flex items-center justify-center border-none shadow-none`}
        />
    );
};

export default ShortlistCandidate;